import {useState} from 'react';
import {UserId} from '@legit-health/ui';
import {Box} from '@mui/material';
import {useTranslation} from 'react-i18next';
import StepContainer from '@/shared/components/diagnosticReport/DiagnosticReportForm/steps/StepContainer';
import {EncounterId} from '@/shared/interfaces/Encounter';
import {ImageProtocolCaptureResult} from '../../ImageProtocolCaptureContent';
import ApasiGlobalForm from './components/ApasiGlobalForm';
import InstructionsStep from './components/InstructionsStep';
import {BODY_PARTS_ARRAY} from './consts';

interface ApasiGlobalWizardProps {
  patientId: UserId;
  onComplete: (result: ImageProtocolCaptureResult) => void;
}

const INSTRUCTIONS_STEP = 0;
const CAPTURE_STEP = 1;
const TOTAL_STEPS = 1 + BODY_PARTS_ARRAY.length;

export default function ApasiGlobalWizard({patientId, onComplete}: ApasiGlobalWizardProps) {
  const {t} = useTranslation([
    'practitioner/common',
    'shared/common',
    'shared/imageProtocol',
    'ui'
  ]);
  const [currentStep, setCurrentStep] = useState<typeof INSTRUCTIONS_STEP | typeof CAPTURE_STEP>(
    INSTRUCTIONS_STEP
  );

  function handleSuccess(encounterId: EncounterId) {
    onComplete({encounterId});
  }

  return (
    <Box sx={{px: 2}}>
      <StepContainer>
        {currentStep === INSTRUCTIONS_STEP ? (
          <InstructionsStep
            activeStep={0}
            totalSteps={TOTAL_STEPS}
            onNext={() => setCurrentStep(CAPTURE_STEP)}
            t={t}
          />
        ) : (
          <ApasiGlobalForm
            patientId={patientId}
            t={t}
            onSuccess={handleSuccess}
            onBackToInstructions={() => setCurrentStep(INSTRUCTIONS_STEP)}
          />
        )}
      </StepContainer>
    </Box>
  );
}
